import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Team  {
    _originalTypeClassName = "ekylikeio.BO.Team";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Team.translate = translateService;
}
this.Images = [];
this.Id = null;
this.TeamName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TeamName:any;
Images:any;
static setImages = ($this, items) => {
                if (items == null) items = [];
                if ($this.Images == null) $this.Images = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Images.length > 0) {
                    Domain.Team.removeImages($this, $this.Images[0]);
                }

                Domain.Team.addManyImages($this, copyItems);
            }
static addManyImages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Team.addImages($this, items[i]);
                }
            }
static addImages = ($this, item) => {
                if ($this.Images == null) $this.Images = [];
                if (item == null || $this.Images.indexOf(item) > -1) return;
                $this.Images.push(item);
}
static addRangeImages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Team.addImages($this, item));
            }
static removeImages = ($this, item) => {
                if ($this == null || $this.Images == null || $this.Images.indexOf(item) === -1) return;
                var _index = $this.Images.indexOf(item);
                $this.Images.splice(_index, 1);
}
static clearImages = ($this) => { $this.Images = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}